export interface ConnectionConsoleFactories<Route, NavigationItem, Provider> {
  createRoutes: () => Route[];
  createNavigationItems: () => NavigationItem[];
  createProviders: () => Provider[];
}

export interface ConnectionConsoleActivation<Route, NavigationItem, Provider> {
  enabled: boolean;
  routes: Route[];
  navigationItems: NavigationItem[];
  providers: Provider[];
}

export function createConnectionConsoleActivation<Route, NavigationItem, Provider>(
  value: string | undefined,
  factories: ConnectionConsoleFactories<Route, NavigationItem, Provider>,
  successorValue?: string
): ConnectionConsoleActivation<Route, NavigationItem, Provider> {
  if (value !== 'true' && successorValue !== 'true') {
    return { enabled: false, routes: [], navigationItems: [], providers: [] };
  }

  return {
    enabled: true,
    routes: factories.createRoutes(),
    navigationItems: factories.createNavigationItems(),
    providers: factories.createProviders(),
  };
}

export const isConnectionConsoleEnabled = (
  value = import.meta.env.VITE_REMOTE_MCP_OAUTH_BETA_ENABLED,
  successorValue = import.meta.env.VITE_REMOTE_MCP_VALUE_LOOP_ENABLED
): boolean => value === 'true' || successorValue === 'true';
